<app-header [isAlerts]="true"></app-header>
<ng-container *ngIf="customersPageViewModel$ | async as viewModel">
  <ion-content id="main-content" class="gray-content-bg">
    <app-manage-alerts-header></app-manage-alerts-header>
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <div class="back-to-overview-container" data-cy="back-to-overview">
            <ion-icon
              class="back-to-overview-icon"
              name="chevron-back"
            ></ion-icon
            ><app-breadcrumbs
              [breadcrumbs]="viewModel?.breadcrumbs"
            ></app-breadcrumbs>
          </div>
          <ion-card class="group-customers-container">
            <ion-card-content class="group-customers-content">
              <ion-grid>
                <ion-row
                  class="group-tabs-row"
                  *ngIf="viewModel.notificationGroupIds.length > 1"
                >
                  <ion-col
                    *ngFor="let group of viewModel.notificationGroupIds"
                    [class.active]="group.id === viewModel.activeGroupId"
                    class="group-tab"
                    size="auto"
                    (click)="onGroupSelected(group)"
                  >
                    {{ ('i18n.notifications.preferences.' + group.name + '_TAB')
                    | translate }}
                  </ion-col>
                </ion-row>
                <ion-row
                  class="group-customers-list-header"
                  [class.has-tabs]="viewModel.notificationGroupIds.length > 1"
                >
                  <ion-col size="12" class="group-customers-list-header-title">
                    Customers
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" class="group-customers-list-subheader">
                    <span
                      >{{ 'i18n.notifications.preferences.alertsActive' |
                      translate }}
                    </span>
                    <span
                      >{{
                      viewModel?.enabledCustomerCount[viewModel.activeGroupId]
                      }}</span
                    >
                    <span>
                      {{ 'i18n.notifications.preferences.of' | translate }}
                    </span>
                    <span> {{ viewModel?.customerCount}} </span>
                    <span>
                      {{ 'i18n.notifications.preferences.ofCustomers' |
                      translate }}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row class="group-customers-list-toolbar">
                  <ion-col size="12" size-md="6" class="left-col">
                    <div class="customer-selection-search-wrapper">
                      <ion-searchbar
                        id="customer-selection-searchbar"
                        data-cy="customer-selection-searchbar"
                        class="customer-selection-search search"
                        mode="ios"
                        debounce="1000"
                        (ionInput)="onSearchInput($event.detail.value)"
                        placeholder="{{ 'i18n.notifications.preferences.searchcustomers' | translate
                      }}"
                      >
                      </ion-searchbar>
                    </div>
                  </ion-col>
                  <ion-col size="12" size-md="6" class="right-group">
                    <div class="right-wrapper">
                      <ion-button
                        *ngIf="!viewModel.sortToggle"
                        class="usf-outline-green-button button sort-button"
                        (click)="onSortClick()"
                      >
                        <span
                          >{{ 'i18n.common.sortAscending' | translate }}</span
                        >
                        <ion-img src="assets/icon/sort-asc.svg"></ion-img>
                      </ion-button>
                      <ion-button
                        *ngIf="viewModel.sortToggle"
                        class="usf-outline-green-button button sort-button"
                        (click)="onSortClick()"
                      >
                        <span
                          >{{ 'i18n.common.sortDescending' | translate }}</span
                        >
                        <ion-img src="assets/icon/sort-desc.svg"></ion-img>
                      </ion-button>
                      <div class="select-all-container">
                        <ion-label class="select-all-label"
                          >{{ 'i18n.common.selectAll' | translate }}</ion-label
                        >
                        <ion-checkbox
                          mode="ios"
                          slot="end"
                          [indeterminate]="viewModel.enabledCustomerCount[viewModel.activeGroupId] !== 0 && viewModel.customerCount !== viewModel.enabledCustomerCount[viewModel.activeGroupId]"
                          [checked]="viewModel.customerCount === viewModel.enabledCustomerCount[viewModel.activeGroupId]"
                          (ionChange)="onSelectAllToggled($event.detail.checked)"
                        ></ion-checkbox>
                      </div>
                    </div>
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12" class="group-customers-list">
                    <cdk-virtual-scroll-viewport
                      itemSize="67"
                      [minBufferPx]="isMobile ? 300 : 660"
                      [maxBufferPx]="isMobile ? 1000 : 1600"
                      class="group-customers-list-virtual-scroll"
                    >
                      <div class="group-customers-list-grid">
                        <div
                          *cdkVirtualFor="let customer of viewModel.customers[viewModel.activeGroupId]; trackBy: trackByCustomer; templateCacheSize: 30;"
                          class="group-customer-row"
                        >
                          <div size="10" class="group-customer-label-col">
                            <span class="customer-name"
                              >{{ customer.customerName }} ({{
                              customer.customerNumber }})</span
                            >
                          </div>
                          <div size="2" class="group-customer-checkbox-col">
                            <ion-checkbox
                              [checked]="customer.isEnabled"
                              mode="ios"
                              (ionChange)="onCustomerToggled(customer, $event.detail.checked)"
                            ></ion-checkbox>
                          </div>
                        </div>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
    <app-footer></app-footer>
  </ion-content>
</ng-container>
